/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef } from "react";
import { Provider } from "react-redux";
import "./productCarousel.scss";
import Store from "~/common/Store";
import CarouselMember from "./Carousel/CarouselMember";
import { CarouselItem } from "./Carousel/CarouselItem";
import RequestQuoteSlide from "./Carousel/Slides/RequestQuoteSlide";
import { useCtrImpressionTracking } from "~/analytics/ClickThroughRateTracking/useCtrImpressionTracking";

interface Props {
  carouselItems: CarouselItem[];
  itemNumber: string;
}
const CustomersAlsoViewedCarousel = ({ carouselItems, itemNumber }: Props) => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const hasActiveSale = carouselItems.some((item) => item.displaySalePrice);
  useCtrImpressionTracking(carouselRef, {
    type: "CustomersAlsoViewed",
    source: itemNumber,
  });
  return (
    <Provider store={Store}>
      <div
        ref={carouselRef}
        className="carousel-wrap mb-0 xm:-mb-px xs:mb-3-2/3"
      >
        <div className="clearfix bg-white border-gray-200 border-solid border-0 p-5 mt-1 xm:border-t xm:p-3 xm:mt-0 xs:bg-transparent xs:border-none xs:border-t-0 xs:p-0">
          <div className="carousel-wrap__header">
            <h3 className="pull-left flex items-center mb-0 font-bold leading-none xm:font-semibold xm:leading-5 xs:mb-4">
              Customers Also Viewed
            </h3>
          </div>
        </div>
        <div
          data-component="customers-also-viewed-carousel"
          data-testid="customers-also-viewed-carousel"
          id="customers-also-viewed"
          className="carousel-wrap"
          gtm-carousel-name="Customers Also Viewed"
        >
          <div
            id="other-products"
            className=" carousel-box"
            data-component="carousel"
          >
            <div className="ag-carousel-nav">
              <a className="ag-car-prev" data-control="prev" />
              <a className="ag-car-next" data-control="next" />
            </div>
            <div id="otherProductsCarousel" className="ag-carousel-frame box">
              <ul className="ag-carousel ag-mini" data-slide-width="220">
                {carouselItems.map(
                  (item, index) =>
                    item &&
                    (item.isRequestQuoteEnabled ? (
                      <li className="ag-item">
                        <RequestQuoteSlide item={item} />
                      </li>
                    ) : (
                      <CarouselMember
                        carouselName="CustomersAlsoViewed"
                        originalLinkingItemNumber={itemNumber}
                        item={item}
                        showAddToCart
                        addToCartFormId={`relatedproduct_also-viewed_${index}`}
                        key={index}
                        activeSalePricingClassNames={
                          hasActiveSale ? "h-[37px]" : "h-[22px]"
                        }
                        isMiniCarousel
                      />
                    )),
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Provider>
  );
};

export default CustomersAlsoViewedCarousel;
